import { Card, Input } from "@";
import type { SeoSettingsSectionProps } from "./types";

export const SeoSettingsSection = ({
  register,
  errors,
  show,
}: SeoSettingsSectionProps) => {
  return (
    <Card isOpen={true} title=" إعدادات SEO" className="lg:col-span-2">
      <div className="grid items-center gap-5 lg:grid-cols-3">
        {/* slug */}
        <Input
          star
          label="slug"
          error={errors.slug}
          disabled={!!show}
          input={register("slug")}
        />

        {/* SEO Title */}
        <Input
          star
          label="SEO Title"
          error={errors.seoTitle}
          disabled={!!show}
          input={register("seoTitle")}
        />
        {/* SEO Keywords */}
        <Input
          star
          disabled={!!show}
          error={errors.seoKeywords}
          input={register("seoKeywords")}
          label="SEO Keywords"
        />

        {/* SEO Description */}
        <Input
          star
          style="md:col-span-3"
          type="textarea"
          disabled={!!show}
          error={errors.seoDescription}
          input={register("seoDescription")}
          label="SEO Description"
        />
      </div>
    </Card>
  );
};
